module.exports = __webpack_public_path__ + "static/media/fill_61@3x.0c2e2690.png";